import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\UpdateTaskDossierDashboardController::__invoke
* @see app/Http/Controllers/UpdateTaskDossierDashboardController.php
* @route '/api/tasks-dossier-dashboard/{task}'
*/
const UpdateTaskDossierDashboardController = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTaskDossierDashboardController.url(args, options),
    method: 'put',
})

UpdateTaskDossierDashboardController.definition = {
    methods: ["put"],
    url: '/api/tasks-dossier-dashboard/{task}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\UpdateTaskDossierDashboardController::__invoke
* @see app/Http/Controllers/UpdateTaskDossierDashboardController.php
* @route '/api/tasks-dossier-dashboard/{task}'
*/
UpdateTaskDossierDashboardController.url = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { task: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { task: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            task: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        task: typeof args.task === 'object'
        ? args.task.id
        : args.task,
    }

    return UpdateTaskDossierDashboardController.definition.url
            .replace('{task}', parsedArgs.task.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\UpdateTaskDossierDashboardController::__invoke
* @see app/Http/Controllers/UpdateTaskDossierDashboardController.php
* @route '/api/tasks-dossier-dashboard/{task}'
*/
UpdateTaskDossierDashboardController.put = (args: { task: string | number | { id: string | number } } | [task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateTaskDossierDashboardController.url(args, options),
    method: 'put',
})

export default UpdateTaskDossierDashboardController